import { Eyebrow, SectionTitle } from "../Eyebrow";

const FOUNDERS = [
    {
        name: "Edina Berisha",
        role: "Cofondatrice",
        img: "/team/edina-berisha.jpg",
        linkedin: "https://www.linkedin.com/in/edina-berisha-59b4a778/",
        bio: "Ancienne chargée d'affaires entreprises senior chez BNP Paribas, passée par la Banque Palatine et la Caisse d'Épargne Rhône Alpes (Groupe BPCE). Diplômée en finance de l'IAE Lyon.",
    },
    {
        name: "Hugo Daugeron-Mijoin",
        role: "Cofondateur",
        img: "/team/hugo-daugeron-mijoin.jpg",
        linkedin: "https://www.linkedin.com/in/hugo-dm/",
        bio: "Ancien chargé d'affaires entreprises senior à la Banque Palatine (Groupe BPCE), passé par LCL, la Caisse d'Épargne et BNP Paribas. Diplômé en banque-finance de Paris 1 Panthéon-Sorbonne.",
    },
];

const personLd = (f) => ({
    "@context": "https://schema.org",
    "@type": "Person",
    name: f.name,
    url: f.linkedin,
    jobTitle: f.role === "Cofondatrice" ? "Co-fondatrice" : "Co-fondateur",
    worksFor: { "@type": "Organization", name: "FOD by DMB Partners" },
    sameAs: [f.linkedin],
    knowsAbout: ["Optimisation des frais bancaires", "Négociation bancaire", "Financement des entreprises"],
    alumniOf: ["BNP Paribas", "Groupe Crédit Agricole", "Groupe BPCE"],
});

const FounderCard = ({ f }) => (
    <article data-testid={`founder-${f.img.split("/").pop().replace(".jpg", "")}`} className="bg-white border border-border-default rounded-2xl p-7 flex flex-col gap-4">
        <div className="flex items-center gap-4">
            <img src={f.img} alt={f.name} width={84} height={84} loading="lazy" className="w-[84px] h-[84px] rounded-full object-cover shrink-0" />
            <div className="flex flex-col gap-0.5">
                <h3 className="m-0 text-xl font-bold">{f.name}</h3>
                <span className="text-sm font-semibold text-gold-text">
                    {f.role} ·{" "}
                    <a href={f.linkedin} target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 hover:text-navy transition-colors">
                        LinkedIn
                    </a>
                </span>
            </div>
        </div>
        <p className="m-0 text-[15px] leading-[1.65] text-grey-text">{f.bio}</p>
    </article>
);

export const Founders = () => (
    <section className="bg-cream border-y border-border-default" data-testid="apropos-founders">
        <div className="mx-auto max-w-[1180px] px-4 md:px-8 lg:px-12 py-12 md:py-16 lg:py-[88px] flex flex-col gap-8">
            <div className="flex flex-col gap-3.5 max-w-[820px]">
                <Eyebrow>15 ans d'expérience bancaire cumulés au service des PME / ETI</Eyebrow>
                <SectionTitle>Ils connaissent les rouages bancaires, de l'intérieur.</SectionTitle>
                <p className="m-0 text-base leading-[1.7] text-grey-text">
                    Edina BERISHA et Hugo DAUGERON-MIJOIN ont créé en 2024 FOD by DMB Partners, le seul service permettant aux dirigeants de PME / ETI de comprendre leurs frais bancaires, de réduire ces coûts financiers et surtout de remettre du lien avec leurs banquiers.
                </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {FOUNDERS.map((f) => <FounderCard key={f.name} f={f} />)}
            </div>
            <div data-testid="founders-medef" className="border-t border-border-default pt-6 flex flex-col md:flex-row items-center gap-[22px] text-center md:text-left">
                <a href="https://www.medefparis.fr/" target="_blank" rel="noopener noreferrer" aria-label="MEDEF Paris (nouvel onglet)" data-testid="founders-medef-link" className="shrink-0 inline-flex transition-opacity hover:opacity-80">
                    <img src="/media/medef-paris.png" alt="MEDEF Paris" loading="lazy" className="h-11 md:h-14 w-auto" />
                </a>
                <span aria-hidden="true" className="hidden md:block w-px h-11 bg-border-default" />
                <div className="flex flex-col gap-1">
                    <p className="m-0 text-navy text-[16px] font-semibold">DMB Partners, qui porte la marque FOD, est adhérent du MEDEF Paris</p>
                    <p className="m-0 text-grey-text-soft text-[14px]">Edina et Hugo y représentent le cabinet.</p>
                </div>
            </div>
            <script
                type="application/ld+json"
                data-testid="founders-jsonld"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(FOUNDERS.map(personLd)) }}
            />
        </div>
    </section>
);
